import React from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const RevenueChart: React.FC = () => {
  const options: ApexOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: { show: false },
      background: "transparent",
    },
    theme: {
      mode: "dark",
    },
    colors: ["#10B981", "#F59E0B"],
    stroke: {
      curve: "smooth",
      width: 2,
    },
    grid: {
      borderColor: "rgba(255, 255, 255, 0.1)",
      strokeDashArray: 4,
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          colors: "#9CA3AF",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#9CA3AF",
        },
        formatter: (value) => `$${value / 1000}K`,
      },
    },
    tooltip: {
      theme: "dark",
      y: {
        formatter: (value) => `$${value.toLocaleString()}`,
      },
    },
    legend: {
      labels: {
        colors: "#9CA3AF",
      },
    },
  };

  const series = [
    {
      name: "Revenue",
      data: [
        85000, 92000, 88000, 95000, 110000, 120000, 115000, 130000, 140000,
        135000, 150000, 165000,
      ],
    },
    {
      name: "Expenses",
      data: [
        45000, 48000, 52000, 50000, 55000, 58000, 60000, 62000, 65000, 68000,
        70000, 75000,
      ],
    },
  ];

  return (
    <div className="bg-white dark:bg-[#1a1b1c] border border-gray-200 dark:border-gray-700 rounded-lg p-6 mt-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Revenue vs. Expenses
      </h3>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  );
};

export default RevenueChart; 